export const LIST_ADMINISTRATIONS = 'ADMINISTRATIONS/LIST_ADMINISTRATIONS'
export const LIST_ADMINISTRATIONS_SUCCESS = 'ADMINISTRATIONS/LIST_ADMINISTRATIONS_SUCCESS'
export const LIST_ADMINISTRATIONS_FAILED = 'ADMINISTRATIONS/LIST_ADMINISTRATIONS_FAILED'

export const CLEAR_ADMINISTRATIONS = 'ADMINISTRATIONS/CLEAR_ADMINISTRATIONS'

export const UPDATE_ADMINISTRATION_ITEM = 'ADMINISTRATIONS/UPDATE_ADMINISTRATION_ITEM'
